// Billing helpers shared by the invoice editor and the Job billing report.

// Most NZ companies invoice on a set day of the month (commonly the 20th).
// Returns the most recent occurrence of that day as YYYY-MM-DD, or null.
export const cutoffDate = (day) => {
  const d = parseInt(day, 10);
  if (!d || d < 1 || d > 31) return null;
  const today = new Date();
  let y = today.getFullYear();
  let m = today.getMonth();
  if (today.getDate() < d) m -= 1;
  if (m < 0) { m = 11; y -= 1; }
  const last = new Date(y, m + 1, 0).getDate();
  const dd = Math.min(d, last);
  return `${y}-${String(m + 1).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
};
